import {Injectable} from "@angular/core";
import {createFeatureSelector, createSelector, Store} from "@ngrx/store";
import * as fromPolygons from "../reducers/polygon.reducer";
import {Observable} from "rxjs";
import {Provider} from "../../model/providers";


@Injectable()
export class PolygonsSelector {
  constructor(private readonly store: Store) {
  }

  getPolygonsState = createFeatureSelector<fromPolygons.State>('polygons');

  getPolygonsBk(): Observable<any> {
    return this.store.select((createSelector(
      this.getPolygonsState,
      (state: fromPolygons.State) => state.bkPolygonData
    )));
  };
}
